const RootSM = {
  state: {
    showNavbar: false,
    file_upload: null,
  },
  reducers: {
    setRoot(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    // Create your dispatch here
  }),
};

export default RootSM;
